class DispatcherSearchByDetails{
constructor(dispatcherSearchByDetails?:DispatcherSearchByDetails){
this.formatedAddress=dispatcherSearchByDetails==undefined?'':dispatcherSearchByDetails.formatedAddress==undefined?'':dispatcherSearchByDetails.formatedAddress;
}
formatedAddress?:string;
}

export {DispatcherSearchByDetails}